import { ReactElement, Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { BetSlipEventObj, UkBets } from 'interfaces/bet-data';
import './index.less';

const { Advanced } = lazy(
  () => import(/* webpackChunkName: "betslip-advanced-ew" */ './advanced')
);

const { Single } = lazy(
  () => import(/* webpackChunkName: "betslip-single-ew" */ './single')
);

const { Basic } = lazy(
  () => import(/* webpackChunkName: "betslip-Basic-ew" */ './basic')
);

const EW_TYPES = {
  0: Single,
  1: Advanced,
  2: Basic
};

// @Todo make ui same and wrap with HObetTypePC with type based functional

export const EachWay = (props: {
  type: 0 | 1 | 2;
  event?: BetSlipEventObj | UkBets;
  index?: number;
}): ReactElement => {
  const View = EW_TYPES[props.type];

  return (
    <div className={`${isMobile() && 'mobile-each-way '} each-way__contanier`}>
      <Suspense fallback={null}>
        <View event={props.event} index={props.index || null} />
      </Suspense>
    </div>
  );
};
